import { render, staticRenderFns } from "./download.vue?vue&type=template&id=5fbfe8c2&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"
import style0 from "./download.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fbfe8c2')) {
      api.createRecord('5fbfe8c2', component.options)
    } else {
      api.reload('5fbfe8c2', component.options)
    }
    module.hot.accept("./download.vue?vue&type=template&id=5fbfe8c2&", function () {
      api.rerender('5fbfe8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pdf/download.vue"
export default component.exports